export enum TypeChoiceIdx {
  LEETCODE = 0,
  CLI = 1,
  FRONTEND = 2,
  FULLSTACK = 3,
  BACKEND = 4,
  CLOUD = 5,
}
